import jwtDecode from 'jwt-decode';

class Utility {
  static calculateElapsedTimeInSeconds(stateDate: number, endDate: number): number {
    if (!stateDate || !endDate) {
      return -1;
    } else {
      return Math.round((endDate - stateDate) / 1000);
    }
  }

  static setBit(value: number, bitPosition: number): number {
    return value | (1 << bitPosition);
  }

  static clearBit(value: number, bitPosition: number): number {
    const mask = ~(1 << bitPosition);
    return value & mask;
  }

  static bitIsSet(value: number, bitPosition: number): boolean {
    return (value & (1 << bitPosition)) === 0 ? false : true;
  }

  static adjustTextForMaximumLength(value: string, maximumLength: number) {
    if (value.length > maximumLength) {
      return value.substring(0, maximumLength) + '...';
    }
    return value;
  }

  static getValueFromJWT(jwt: string | undefined, key: string): unknown | undefined {
    if (jwt) {
      const token = jwtDecode(jwt) as any;
      return token[key];
    }
    return undefined;
  }

  static getValueFromJwtWithDefaultValue<T>(jwt: string | undefined, key: string, defaultValue: T): T {
    if (jwt) {
      const token = jwtDecode(jwt) as any;
      const value = token[key];
      return value !== undefined ? value : defaultValue;
    }
    return defaultValue;
  }

  static getAccommodationFromJWT<T>(jwt: string | undefined, key: string, defaultValue: T): T {
    return Utility.getNestedSettingFromJWT(jwt, 'accommodations', key, defaultValue);
  }

  static getFormPreviewSettingValueFromJWT<T>(jwt: string | undefined, key: string, defaultValue: T): T {
    return Utility.getNestedSettingFromJWT(jwt, 'formPreviewSettings', key, defaultValue);
  }

  private static getNestedSettingFromJWT<T>(
    jwt: string | undefined,
    firstKey: string,
    secondKey: string,
    defaultValue: T
  ): T {
    if (jwt) {
      const token = jwtDecode(jwt) as any;
      const container = token[firstKey];

      if (container) {
        const value = container[secondKey];
        return value !== undefined ? value : defaultValue;
      }
    }
    return defaultValue;
  }

  static getIncompleteAndFlaggedText(
    incompleteCount: number,
    flagCount: number,
    incompleteWrapFunction: ((value: number) => string) | null,
    flaggedWrapFunction: ((value: number) => string) | null
  ): string {
    const i18n = (window as any).i18n.global;
    const count = incompleteCount + flagCount;
    if (count > 0) {
      let text = i18n.t('common.there') + ' ' + (count > 1 ? i18n.t('common.are') + ' ' : i18n.t('common.is') + ' ');

      if (incompleteCount > 0) {
        text += incompleteWrapFunction
          ? incompleteWrapFunction(incompleteCount)
          : incompleteCount +
            ' ' +
            (incompleteCount > 1 ? i18n.t('review.incomplete_plural') : i18n.t('review.incomplete'));
        text += flagCount > 0 ? ' ' + i18n.t('common.and') + ' ' : '';
      }

      if (flagCount > 0) {
        text += flaggedWrapFunction ? flaggedWrapFunction(flagCount) : flagCount + ' ' + i18n.t('review.flagged');
      }

      text += ' ' + (count > 1 ? i18n.t('entity.questions') : i18n.t('entity.question')) + '. ';

      return text;
    }

    return '';
  }

  static convertToArrayOfMaps(array: Array<never>): Array<Map<string, string>> {
    const arrayOfMaps: Array<Map<string, string>> = new Array<Map<string, string>>();

    array.forEach((element) => {
      arrayOfMaps.push(new Map(Object.entries(element)));
    });

    return arrayOfMaps;
  }
}

export default Utility;
